// Components==============
import { motion } from 'framer-motion';
import React, { useState } from 'react';
import './SmallScreenWarning.module.scss';
import { useMediaQ } from 'hooks/useMediaQ';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faMobile } from '@fortawesome/pro-solid-svg-icons';
import Button from 'components/UI/Button/Button';
// =========================

export const minWidth = 1000;
export const minHeight = 700;

export default function SmallScreenWarning() {
    const [warningOpen, setWarningOpen] = useState(true);
    const widthWarning = useMediaQ('max', minWidth);
    const heightWarning = useMediaQ('max', minHeight, false);
    const windowWidth = window.innerWidth;
    const windowHeight = window.innerHeight;

    function closeWarning() {
        setWarningOpen(false);
        localStorage.setItem('smallScreenWarningDismissed', 'true');
    }

    return (
        <>
            {localStorage.getItem('smallScreenWarningDismissed') !== 'true' &&
                warningOpen &&
                (widthWarning || heightWarning) && (
                    <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1 }}
                        styleName="small-screen-warning"
                    >
                        <div styleName="inner">
                            <div styleName="image">
                                <img
                                    alt="Spiek the dog with a small screen"
                                    src="/images/small-screen-warning/spiek-screen.svg"
                                />
                            </div>
                            <div styleName="text">
                                <h3>Je hebt een erg klein scherm</h3>
                                <div styleName="paragraph">
                                    <p>
                                        Spiek Digitaal is gemaakt voor schermen
                                        van minimaal {minWidth}x{minHeight}{' '}
                                        pixels. Jouw scherm is momenteel
                                        kleiner, namelijk {windowWidth}x
                                        {windowHeight}.
                                        <br />
                                        Je kunt doorgaan naar Spiek Digitaal,
                                        maar het kan zijn dat sommige dingen er
                                        gek uitzien of niet alles op je scherm
                                        past.
                                    </p>
                                    {windowHeight > windowWidth && (
                                        <div styleName="warning">
                                            <p>
                                                Als je je scherm kan draaien,
                                                heb je net wat meer ruimte.
                                            </p>
                                            <motion.div
                                                initial={{
                                                    rotate: 0,
                                                }}
                                                animate={{
                                                    rotate: 90,
                                                }}
                                                exit={{
                                                    rotate: 0,
                                                }}
                                                transition={{
                                                    duration: 1,
                                                    repeat: Infinity,
                                                    repeatDelay: 3,
                                                }}
                                            >
                                                <FontAwesomeIcon
                                                    icon={faMobile}
                                                />
                                            </motion.div>
                                        </div>
                                    )}
                                </div>
                                <Button onClick={closeWarning}>
                                    Toch verder gaan naar Spiek digitaal
                                </Button>
                            </div>
                        </div>
                    </motion.div>
                )}
        </>
    );
}
